import type { ModuleOptions } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";
import type { PicklistResource } from "@exonn/js-sdk";

export const module: ModuleOptions<PicklistResource> = {
  resource: ResourceEnum.Picklist,
  bigIcon: <i className={"icon-20-order_proces"} />,
  smallIcon: <i className={"icon-15-order_proces"} />,
  disableCreate: true,
  disableDelete: true,
  tabs: {
    edit: {
      getTitle: (resource) => resource.number,
    },
  },
};
